import type { Chatbot, ChatbotDraftState } from './types';

// Mirrors server_pray LIVE_CONFIGURATION_FIELDS: the draft fields Publish copies onto the live chat.
const LIVE_CONFIGURATION_FIELDS = [
  'instructions',
  'conversation_starter_1',
  'conversation_starter_2',
  'conversation_starter_3',
  'chat_only_instructions',
  'persona_characteristics',
  'persona_name',
  'persona_role',
  'persona_tone',
  'ai_disclaimer_text',
  'is_ai_disclaimer_enabled',
] as const satisfies readonly (keyof ChatbotDraftState & keyof Chatbot)[];

type LiveValue = string | boolean | null | undefined;

const normalize = (value: LiveValue) => (value === '' || value === undefined ? null : value);

const draftDiffersFromLive = (chatbot: Chatbot) => {
  const draft = chatbot.draft_state ?? {};
  return LIVE_CONFIGURATION_FIELDS.some(
    (field) => draft[field] !== undefined && normalize(draft[field]) !== normalize(chatbot[field])
  );
};

/**
 * Whether Publish would change what users talk to. Trusts the server's flag (server_pray S6, which also
 * counts writing-style changes) and otherwise compares the saved draft with the live fields.
 */
export const hasUnpublishedChanges = (chatbot: Chatbot | undefined) => {
  if (!chatbot) return false;
  return chatbot.has_unpublished_changes ?? draftDiffersFromLive(chatbot);
};
